<template>
    <div
        class="hero large-content hero-graphic"
        :class="content.heroGraphicText.heroBackgroundColor"
        :style="{ backgroundImage: `url(${content.heroGraphicText.image})` }"
    >
        <div id="anchor-aos" class="container-xxl mt-auto">
            <div class="row">
                <div class="col-12 max-width">
                    <div
                        class="title-wrapper"
                        data-aos="fade-up"
                        data-aos-offset="-800"
                        data-aos-delay="500"
                    >
                        <h1
                            class="hero-title font-display move-left"
                            v-html="content.heroGraphicText.heroTitleNoSplit"
                        ></h1>
                        <h5
                            v-if="content.heroGraphicText.heroSubtitle"
                            class="hero-subtitle"
                        >
                            {{ content.heroGraphicText.heroSubtitle }}
                        </h5>
                        <p
                            v-if="content.heroGraphicText.heroText"
                            class="hero-textblock"
                        >
                            {{ content.heroGraphicText.heroText }}
                        </p>

                        <a
                            v-if="content.heroGraphicText.heroLink && !isFormationsVariant"
                            :href="content.heroGraphicText.heroLink.fr"
                            class="link-arrow right text-uppercase"
                        >
                            {{ content.heroGraphicText.heroLinkText }}
                        </a>

                        <a
                            v-else-if="content.heroGraphicText.heroLink && isFormationsVariant && !filters.length"
                            :href="content.heroGraphicText.heroLink.fr"
                            class="link-arrow right text-uppercase"
                            @click.prevent="setSidebarMainStep('intro')"
                        >
                            {{ content.heroGraphicText.heroLinkText }}
                        </a>

                        <div v-if="isFormationsVariant" class="d-flex flex-column flex-md-row align-items-md-stretch">
                            <a class="button btn-hero" @click.prevent="setSidebarMainStep('creation')">
                                <span class="my-auto">{{$t('Domaines de création')}}</span>
                            </a>
                            <a class="button btn-hero" @click.prevent="setSidebarMainStep('jobs')">
                                <span class="my-auto">{{$t('Métiers')}}</span>
                            </a>
                            <a class="button btn-hero" @click.prevent="setSidebarMainStep('organisationsProfessionnelles')">
                                <span>
                                    <span>{{$t('Organisations')}}</span><br/>
                                    <span>{{$t('professionnelles')}}</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'HeroGraphicText',

    props: {
        isFormationsVariant: {
            type: Boolean,
            default: false
        },
        filters: {
            type: Array,
            default: () => []
        }
    },

    // On loaded...
    mounted() {
    },

    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['content']),
    },

    methods: {
        ...mapActions(['setSidebarMainStep'])
    },
}
</script>
